import { api } from "../../api";

export const videoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getVideosByApi: builder.query({
      query: (apiEndpoint) => ({
        url: apiEndpoint,
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }),
    }),
    updateView: builder.mutation({
      query: ({ videoId, completed, lastTime,duration }) => ({
        url: "/views/update",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          videoId: String(videoId),
          completed: String(completed),
          lastTime: String(lastTime),
          duration: String(duration),
        }).toString(),
      }),
    }),

    getView: builder.mutation({
      query: ({ videoId }) => ({
        url: "/views/get",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ videoId: String(videoId) }).toString(),
      }),
    }),
    searchVideos: builder.mutation({
      query: ({ title, page }) => ({
        url: "/videos/search",
        method: "POST",
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          title,
          page: page.toString(),
          limit: 50,
        }).toString(),
      }),
      transformResponse: (response) => {
        const resultArray = response.data?.result ?? [];
        return {
          results: resultArray,
          total_results: response.data?.total_results ?? resultArray.length,
          total_pages: response.data?.total_pages ?? 1,
        };
      },
    }),
    getRecentViews: builder.query({
      query: () => ({
        url: '/views/recent',
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      }),
      transformResponse: (response) => {
        return response.data?.results || response.data || [];
      }
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetVideosByApiQuery,
  useUpdateViewMutation,
  useGetViewMutation,
  useSearchVideosMutation,
  useGetRecentViewsQuery
} = videoApi;
